import { filterStores } from '../../state';
import type { FilterSections, ReadonlySearchParams } from '../../types';
import { getInitialFilter } from '../getInitialFilter/getInitialFilter';
import { getTouchedFilterItemsFromParams } from '../getTouchedFilterItemsFromParams/getTouchedFilterItemsFromParams';

export function setFilter({
	filterSections,
	searchParams,
	pageParams,
	trackPrefix
}: {
	filterSections: FilterSections;
	searchParams: ReadonlySearchParams;
	pageParams: string[];
	trackPrefix?: string;
}) {
	const initialFilter = getInitialFilter({
		filterSections,
		searchParams
	});

	const { filterStore, touchedItemsStore, filterSectionsStore, pageParamsStore, trackPrefixStore } =
		filterStores;

	filterStore.update(() => initialFilter);

	touchedItemsStore.update(() =>
		getTouchedFilterItemsFromParams({
			filter: initialFilter,
			searchParams
		})
	);

	filterSectionsStore.update(() => filterSections);

	pageParamsStore.update(() => pageParams);

	trackPrefixStore.update(() => trackPrefix ?? null);
}
